import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';

function TrnThesis_popup() {

    const [data, setData] = useState({});
    const [emogList, setEmogList] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('trnThesisData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/trnThesisDetail.do', {
                params: sendData
            });
            setData(response.data);
            console.log(response.data);
            console.log(sendData);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };

    const [searchParams, setSearchParams] = useState({
        THESIS_TYPE: '',
        POST_NM: '',
        AHTHOR_TYPE: '',
        CONTENT: '',
        BIGO: '',
        EMOGCODE: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/trmsapi/trnlst/trmsEmogList.do', {
                    params: {}
                });
                setEmogList(response.data.trnEmogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        popupData();
    }, []);

    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            THESIS_TYPE: data.THESIS_TYPE,
            POST_NM: data.POST_NM,
            EMOGCODE: data.EMOGCODE || sendData.EMOGCODE,
            AHTHOR_TYPE: data.AHTHOR_TYPE,
            CONTENT: data.CONTENT,
            BIGO: data.BIGO,
        }));
    }, [data]);

    const save = async () => {
        const requiredFields = [
            { key: 'THESIS_TYPE', label: '구분' },
            { key: 'POST_NM', label: '게시자명' },
            { key: 'AHTHOR_TYPE', label: '저자 구분' },
            { key: 'CONTENT', label: '주요내용' },
        ];

        for (const field of requiredFields) {
            const value = searchParams[field.key];
            if (value === '' || value === null || value === undefined) {
                alert(`${field.label}을(를) 입력(선택)해야합니다.`);
                return;
            }
        }

        const confirmMessage = sendData.flag === "add" ? "저장하시겠습니까?" : "수정하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);
        if (!confirmed) return;

        const addParams = {
            userAuth: localStorage.getItem("userAuth"),
            DETAIL_SN: data.DETAIL_SN || '',
        };

        const totalObj = Object.assign({}, searchParams, addParams);
        console.log(totalObj);
        try {
            const response = await axios.get("/trmsapi/trnlst/trnThesisSave.do", {
                params: totalObj
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    };


    return (
        <div className='popup_container bg_tr_bg'>
            <div className='flex justify-between'>
                <h5 className='sub_title m-0 p-0'>연구 - 논문</h5>
                <div className='flex gap-1'>
                    <button onClick={save} title='저장' className='search_btn bg_tr_primary justify-self-end'>
                        <Icons.Save16w />{sendData.flag === 'add' ? '저장' : '수정'}
                    </button>
                </div>
            </div>
            <div className='com-search tr_pop_th_bg border-l border-r'>
                <form>
                    <hr className='border-t-2 tr_border_soft' />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="35%" />
                            <col width="15%" />
                            <col width="35%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>연번</th>
                                <td>{sendData.IEM_ID || ''}</td>
                                <th>구분</th>
                                <td>
                                    <select
                                        id="THESIS_TYPE"
                                        name="THESIS_TYPE"
                                        className='w-full'
                                        value={searchParams.THESIS_TYPE}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        <option value="A">SCI/E(국내)</option>
                                        <option value="B">SCI/E(국외)</option>
                                        <option value="C">비 SCI/E(국내)</option>
                                        <option value="D">비 SCI/E(국외)</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>게시자 명</th>
                                <td>
                                    <input
                                        type='text'
                                        name='POST_NM'
                                        id='POST_NM'
                                        className='input_style'
                                        value={searchParams.POST_NM}
                                        onChange={handleChange} />
                                </td>
                                <th>소속</th>
                                <td>
                                    <select
                                        name="EMOGCODE"
                                        id="EMOGCODE"
                                        className='w-full'
                                        value={searchParams.EMOGCODE}
                                        onChange={handleChange}
                                    >
                                        {emogList.map((hosp) => (
                                            <option key={hosp.EMOGCODE} value={hosp.EMOGCODE}>
                                                {hosp.EMOGDESC}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>저자 구분</th>
                                <td colSpan={3}>
                                    <select
                                        id="AHTHOR_TYPE"
                                        name="AHTHOR_TYPE"
                                        value={searchParams.AHTHOR_TYPE}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        <option value="1">제1저자</option>
                                        <option value="2">교신저자</option>
                                        <option value="3">공저자</option>
                                        <option value="4">기타</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>주요내용</th>
                                <td colSpan="3">
                                    <textarea
                                        id="CONTENT"
                                        name="CONTENT"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.CONTENT}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td colSpan="3">
                                    <textarea
                                        id="BIGO"
                                        name="BIGO"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.BIGO}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div >
    );
}

export default TrnThesis_popup;